import {UseCase} from '@s-ui/domain'

/**
 * @implements UseCase
 */
export default class GetAdsFromLastSearchUseCase extends UseCase {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Config} deps.repository
   * @param {Config} deps.config
   * @param {Function} deps.log
   * @param {Service} deps.service
   */
  constructor({repository, log, config, service}) {
    super({repository, log, config, service})

    this._repository = repository
    this._log = log
    this._config = config
    this._service = service
    this._fallbackResponse = []
  }

  /**
   * @return {Promise<Object, Error>} list of vehicles
   */
  async execute() {
    this._log('Getting last search')
    const {LAST_SEARCH_ITEMS_COUNT} = this._config.get('search')
    const lastAdsSearchParams = {
      count: LAST_SEARCH_ITEMS_COUNT,
      ...(await this._repository.getLastAdsSearchParams())
    }

    return this._service.execute(lastAdsSearchParams).catch(e => {
      this._log(`failed: ${e}`)
      return this._fallbackResponse
    })
  }
}
